module.exports = "<h4>Trial expired emails</h4> <p>The 'Trial expired' trigger sends emails automatically when a customer's trial comes to an end.</p> ";